export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS 2022.9a8c9426.pdf";